import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "createLabelClassName",
    value: function createLabelClassName() {
      return [styles.checkbox, styles[this.props.state]].join(' ').trim();
    }
  }, {
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, this.props.className].join(' ').trim();
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (!this.props.help) return null;
      return React.createElement('span', {
        className: [styles.help, styles[this.props.help.color]].join(' ')
      }, this.props.help.text);
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return React.createElement('label', {
        className: this.createLabelClassName()
      }, React.createElement('input', {
        type: 'checkbox'
      }), this.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.hasAddons) {
        return this.renderForm();
      }

      return React.createElement('p', {
        className: this.createControlClassName(),
        style: this.props.style
      }, this.renderForm());
    }
  }]);

  return Checkbox;
}(Component);

export { Checkbox as default };
Checkbox.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string,
  hasIcon: PropTypes.bool,
  hasIconRight: PropTypes.bool,
  icon: PropTypes.string,
  hasAddons: PropTypes.bool,
  state: PropTypes.oneOf(['isDisabled']),
  help: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger'])
  })
};
Checkbox.defaultProps = {
  className: ''
};